/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Add_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. CLI tool, CI/CD pipeline" |
*
* @param {Profile_Security_User_Api_Key_Add_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_add_description_placeholder = /** @type {((inputs?: Profile_Security_User_Api_Key_Add_Description_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Add_Description_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("z.B. CLI-Tool, CI/CD-Pipeline")
	return /** @type {LocalizedString} */ ("e.g. CLI tool, CI/CD pipeline")
});